import React, { Component } from 'react';
import Logo from "./icons/logo.png";
import * as API from './api.js';
import './style.css';
import AppConstants from './AppConstants';
import { ActivityPopup } from './ReusableComponents/ActivityPopup.js';
import dateFormat from 'dateformat';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import AeroMeghLogo from "./aeromeghLog.png";
import PDRLLogo from "./pdrl_logo.png";
import { convertAmountToWords, formatToIndianRupees } from './ReusableComponents/reusableFunctions.js';
import LoaderComponent from './ReusableComponents/LoaderComponent.js';
import RenewSubscription from './subscription/Reusable/RenewSubscription.js';
import { BreadCrumbs } from './ReusableComponents/BreadCrumbs.js';
import { toWords } from 'number-to-words';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
 class Invoice extends Component {
    state = {
        user: {},
        type: "",
        org: {},
        loading: true,
        sidebarMode: (this.props.location.state ? this.props.location.state.sidebarMode : "shrunk"),
        invoiceID: this.props.location.state.invoiceId,
        activityPopupObj: {
            item: undefined,
            open: undefined,
            msg: undefined,
        },
        invoice: {},
    }

    parentSidebarSwitch = () => {
        this.setState((state) => ({
            ...state,
            sidebarMode: (state.sidebarMode == "shrunk" ? "expanded" : "shrunk")
        }))
    }

    componentDidMount() {
        if (this.props.location.state.invoice) {
            let { invoice } = this.props.location.state
            let subscription_plan = invoice.subscription_plan
            let basePrice = invoice.price
            let discount = basePrice * (invoice.discount / 100)
            discount = discount.toFixed(2)
            let discounted = basePrice - discount
            let total = discounted.toFixed(2)
            this.setState({
                invoice,
                basePrice,
                discount,
                total,
            }, () => { this.setState({ loading: false }) })
        } else
            API.getInvoice(this.state.invoiceID).then(res => {
                let { invoice } = res
                let subscription_plan = invoice.subscription_plan
                let basePrice = invoice.price
                let discount = basePrice * (invoice.discount / 100)
                discount = discount.toFixed(2)
                let discounted = basePrice - discount
                let total = discounted.toFixed(2)
                this.setState({
                    invoice,
                    basePrice,
                    discount,
                    total,
                }, () => { this.setState({ loading: false }) })
            }).catch(e => {
                this.setState({
                    activityPopupObj: {
                        item: 'ERROR',
                        open: true,
                        msg: "Currupted Invoice",
                    }
                })
            })
    }

    componentWillMount() {
        document.title = `Invoice - ${this.state.invoiceID} - AeroGCS`;
        if (this.props.location.state) {
            let { user, type, organizationID, modelNumber } = this.props.location.state;
            this.setState({
                user,
                type,
                organizationID,
                modelNumber
            })
        } else {
            API.getUserType().then(([blah, type, user]) => {
                this.setState({
                    user,
                    type
                })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }

    downloadPDF = () => {
        const input = document.querySelector('.myDiv');

        html2canvas(input, {
            scale: 3,
            useCORS: true,
            backgroundColor: null,
        }).then(canvas => {
            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const heightLeft = imgHeight;

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
            });

            let position = 0;

            pdf.addImage(
                canvas.toDataURL('image/png'),
                'PNG',
                0,
                position,
                imgWidth,
                imgHeight
            );

            let remainingHeight = heightLeft;
            while (remainingHeight > pageHeight) {
                position -= pageHeight;
                pdf.addPage();
                pdf.addImage(
                    canvas.toDataURL('image/png'),
                    'PNG',
                    0,
                    position,
                    imgWidth,
                    imgHeight
                );
                remainingHeight -= pageHeight;
            }

            pdf.save('invoice.pdf');
        });
    };

    render() {
        let { user } = this.props
        return (
            <div className="wrapper">
                <div className="right-content-new">
                    <ActivityPopup
                        item={this.state.activityPopupObj?.item}
                        open={this.state.activityPopupObj?.open}
                        msg={this.state.activityPopupObj?.msg}
                        close={() => window.location.replace(process.env.REACT_APP_CLIENT_PROTOCOL + "://" + process.env.REACT_APP_CLIENT_HOST + (process.env.REACT_APP_CLIENT_PORT ? process.env.REACT_APP_CLIENT_PORT : ""))}
                    />
                    <div className="top-bar-new" style={{ display: "flex", zIndex: '2' }}>
                      <div className="top-bar-text-new">
                            <BreadCrumbs
                                data={[
                                    {
                                        displayName: "Settings",
                                        pathname: "/profile-settings",
                                        state: {
                                            user
                                        }
                                    },
                                    {
                                        displayName: "Invoice",
                                        pathname: this.props.location.state.user_info ? `/admin/userdetails` : "/profile-settings",
                                        state: {
                                            user,
                                            onPage: 3,
                                            user_info: this.props.location?.state?.user_info || null
                                        }
                                    },
                                    {
                                        displayName: this.state?.invoice?.invoice_number || "-",
                                    }
                                ]}
                            />

                        </div>
                    </div>
                    {this.state.loading ? <LoaderComponent /> : <div className="main-content-new">
                        <ActivityPopup
                            item={this.state.activityPopupObj?.item}
                            open={this.state.activityPopupObj?.open}
                            msg={this.state.activityPopupObj?.msg}
                            close={() => window.location.replace(process.env.REACT_APP_CLIENT_PROTOCOL + "://" + process.env.REACT_APP_CLIENT_HOST + (process.env.REACT_APP_CLIENT_PORT ? process.env.REACT_APP_CLIENT_PORT : ""))}
                        />
                        <div style={{ overflow: "auto", position: "relative" }}>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '20px', justifyContent: "end", maxWidth: "620px", margin: "auto" }}>
                                {this.state.invoice.payment?.payment_status == "due" && !this.props.location.state.adminView && <RenewSubscription data={this.state.invoice} user={this.state.user} />}
                                <a style={{ color: '#007BFF', cursor: 'pointer', fontSize: '15px', }} onClick={() => this.downloadPDF()}>Download Invoice</a>
                            </div>
                            <div style={{ width: '620px', margin: 'auto', border: '1px solid rgba(215, 218, 224, 0.4)', borderRadius: '5px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', color: "#3B3B3B", backgroundColor: '#fff' }}>
                                <div className='myDiv' style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    minHeight: '842px',
                                    position: 'relative',
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '0px 30px', padding: '20px 0px', borderBottom: '1px solid rgba(215, 218, 224, 0.3)', gap: '20px' }}>
                                        <div>
                                            <img src={PDRLLogo} alt="PDRL Logo" width={"150px"} />
                                        </div>
                                        <div style={{ textAlign: 'left', fontSize: "12px", paddingRight: "30px" }}>
                                            <p style={{ margin: '0', fontWeight: 600, color: "#1A1C21" }}>Passenger Drone Reaserch Private Limited (PDRL)</p>
                                            <p style={{ margin: '0', color: "#727272" }}>{this.state.invoice?.from?.address} {this.state.invoice?.from?.state}, {this.state.invoice?.from?.pin_code}, {this.state.invoice?.from?.country}
                                            </p>
                                            <p style={{ margin: '0', color: "#727272" }}>GST No: {this.state.invoice?.from?.gstin}</p>

                                        </div>
                                    </div>
                                    <div style={{ maxWidth: '900px', margin: '0 auto', paddingLeft: '20px', paddingRight: "20px", paddingTop: "20px", paddingBottom: "10px", fontFamily: 'Arial, sans-serif', color: '#5E6470' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                            <div style={{ width: "289px", fontSize: "12px" }}>
                                                <p style={{ margin: "0", fontWeight: "bold", fontSize: "14px" }}>Bill To</p>
                                                <p style={{ margin: "0", fontWeight: "bold", color: "#1E1E1E" }}>{this.state.invoice?.to?.name}</p>
                                                <p style={{ margin: "0" }}>{this.state.invoice?.to?.address}</p>
                                                <p style={{ margin: "0" }}>{this.state.invoice?.to?.state} {this.state.invoice?.to?.pin_code}</p>
                                                <p style={{ margin: "0" }}>{this.state.invoice?.to?.country}</p>
                                                {this.state.invoice?.to?.gstin && <p style={{ margin: "0" }}>GST No: {this.state.invoice?.to?.gstin}</p>}
                                            </div>
                                            <div style={{ width: "289px", paddingLeft: "20px", borderLeft: "1px solid rgba(215, 218, 224, 0.4)", fontSize: "12px", display: "flex", alignItems: "center" }}>
                                                <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                                                    <div style={{ fontWeight: "bold" }}>
                                                        <p style={{ margin: "0" }}>Invoice No.</p>
                                                        <p style={{ margin: "0" }}>Invoice Date</p>
                                                        <p style={{ margin: "0" }}>*Terms</p>
                                                        <p style={{ margin: "0" }}>Due Date</p>
                                                        {this.state.invoice?.payment?.transaction_id && <p style={{ margin: "0" }}>Transaction ID</p>}
                                                    </div>
                                                    <div>
                                                        <p style={{ margin: "0" }}>: {this.state.invoice.invoice_number}</p>
                                                        <p style={{ margin: "0" }}>: {new Date(this.state.invoice.payment.date_time).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                                                        <p style={{ margin: "0" }}>: Due on Receipt</p>
                                                        <p style={{ margin: "0" }}>: {new Date(this.state.invoice.due_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                                                        {this.state.invoice?.payment?.transaction_id &&
                                                            <p style={{ margin: "0" }}>: {this.state.invoice.payment.transaction_id}</p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr style={{ border: 'none', borderTop: '1px solid rgba(215, 218, 224, 0.4)', margin: '20px 0' }} />
                                    </div>

                                    <div style={{ width: '620px', margin: '0 auto', paddingLeft: '22px', paddingRight: '22px', fontFamily: 'Arial, sans-serif', color: '#5E6470' }}>
                                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", color: "#3B3B3B" }}>
                                            <thead>
                                                <tr style={{ backgroundColor: "#f2f2f2", color: "#1E1E1E" }}>
                                                    <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Sr No.</th>
                                                    <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Items & Description</th>
                                                    <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>HSN/SAC</th>
                                                    <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Qty</th>
                                                    <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Rate</th>
                                                    <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>1.</td>
                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                                        <div style={{ fontWeight: "bold", color: "#3B3B3B" }}>{this.state.invoice?.subscription_plan?.replaceAll("_", " ").split(" ").map(word => word.split("").map((letter, i) => i === 0 ? letter.toUpperCase() : letter.toLowerCase()).join("")).join(" ")}</div>
                                                    </td>
                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>998112</td>
                                                    <td style={{ border: "1px solid #ddd", padding: "8px", whiteSpace: "nowrap", textAlign: "center" }}>{this.state.invoice.units}</td>
                                                    <td style={{ border: "1px solid #ddd", padding: "8px", whiteSpace: "nowrap", textAlign: "center" }}>₹{(parseFloat((this.state.invoice.rate))).toFixed(2) || "-"}</td>
                                                    <td style={{ border: "1px solid #ddd", padding: "8px", whiteSpace: "nowrap", textAlign: "center" }}>₹{(parseFloat(this.state.invoice.payment.amount - this.state.invoice.gst_amount)).toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "#3B3B3B" }}>
                                            <div style={{ fontSize: "12px" }}>
                                                <div style={{ fontWeight: "bold", marginBottom: "4px", marginTop: "10px", color: "#1E1E1E" }}>Total In Words</div>
                                                <div style={{ fontStyle: "italic", fontWeight: "bold", color: "#1E1E1E", paddingRight: "10px" }}>
                                                    {convertAmountToWords(parseFloat(this.state.invoice.payment.amount).toFixed(2)).replace(/,/g, " ").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ")}</div>
                                            </div>

                                            <div style={{ minWidth: "250px", border: "1px solid #ddd", borderTop: "none", fontSize: "12px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                                    <span>Subtotal</span>
                                                    <span>₹{(parseFloat(this.state.invoice.payment.amount - this.state.invoice.gst_amount)).toFixed(2)}</span>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "space-between", padding: "8px", borderBottom: "1px dashed #aaa" }}>
                                                    <span>IGST 18%</span>
                                                    <span>+ ₹{(parseFloat(this.state.invoice.gst_amount)).toFixed(2)}</span>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "space-between", padding: "8px", fontWeight: "bold", color: "#1E1E1E" }}>
                                                    <span>Total</span>
                                                    <span>₹{(parseFloat(this.state.invoice.payment.amount)).toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ position: 'absolute', bottom: '13px', left: '20px', fontSize: '8px', color: '#666', width: '100%', paddingBottom: '0px' }}>
                                        *Terms & Conditions apply
                                    </div>
                                    <div style={{ position: 'absolute', bottom: '0px', left: '20px', fontSize: '8px', color: '#666', width: '100%', paddingBottom: '0px', color: '#1E1E1E' }}>
                                        100% Advance Payment
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>)
    }
}

const mapStateToProps = (state) => ({
    user: state.profile.user, 
});


export default withRouter(connect(mapStateToProps)(Invoice));